import React from "react";
import Svg, { Path } from "svgs";

import { animalSize } from "../constants/board";

const Chick = (props) => (
  <Svg height={animalSize} width={animalSize} viewBox="0 0 64 64" {...props}>
    <Path
      fill="#F59E01"
      d="M45.249 60.19c-.83 0-1.592.158-2.213.377a6.68 6.68 0 0 0-1.029-.264V53h-2.365v7.304a6.483 6.483 0 0 0-1.033.264 6.719 6.719 0 0 0-2.213-.377c-2.071 0-3.751.967-3.751 1.447 0 .482 16.355.482 16.355 0 0-.481-1.679-1.448-3.751-1.448zm-17.645 0c-.83 0-1.592.158-2.213.377a6.734 6.734 0 0 0-1.033-.264V53h-2.365v7.304a6.43 6.43 0 0 0-1.029.264 6.719 6.719 0 0 0-2.213-.377c-2.072 0-3.751.967-3.751 1.447 0 .482 16.355.482 16.355 0 0-.481-1.679-1.448-3.751-1.448z"
    />
    <Path
      fill="#F9C802"
      d="M51 43.933c0 11.01-8.509 12.713-19.001 12.713C21.504 56.646 13 54.942 13 43.933c0-14.724 9.292-21.287 18.999-21.287C41.702 22.646 51 29.209 51 43.933z"
    />
    <Path
      fill="#FFE12C"
      d="M44.215 54.972c3.228-17.686-27.565-17.721-24.444.002 3.304 1.335 7.564 1.672 12.221 1.672 4.656 0 8.919-.337 12.223-1.674z"
    />
    <Path
      fill="#F9C802"
      d="M32 41.728c-20 0-20-36.118 0-36.118s20 36.118 0 36.118z"
    />
    <Path
      fill="#F9C802"
      d="M26.064 3.98c1.303 1.793.522 4.238.522 4.238l11.35-.282c-1.299-3.966-4.01-5.694-4.01-5.694.487 1.763-.109 3.18-.109 3.18C32.823 2.942 29.443 2 29.443 2c1.146 1.83.693 3.053.693 3.053-1.82-1.466-4.072-1.073-4.072-1.073z"
    />
    <Path
      fill="#D47706"
      d="M27 27.224h10c0 2.548-2.5 4.264-5 4.264-2.503 0-5-1.717-5-4.264z"
    />
    <Path
      fill="#F59E01"
      d="M37 27.224s-3.212 1.195-5 1.195c-1.786-.001-5-1.195-5-1.195 0-3.169 2.241-5.736 5-5.736 2.761 0 5 2.567 5 5.736z"
    />
    <Path
      fill="#302C3B"
      d="M27.483 20.404c0 1.661-1.119 3.006-2.5 3.006-1.383 0-2.5-1.345-2.5-3.006 0-1.664 1.117-3.008 2.5-3.008 1.381 0 2.5 1.344 2.5 3.008z"
    />
    <Path fill="#FFF" d="M24.144 19.184c0 1.002-1 1.002-1 0s1-1.002 1 0z" />
    <Path
      fill="#302C3B"
      d="M41.517 20.404c0 1.661-1.119 3.006-2.5 3.006-1.383 0-2.5-1.345-2.5-3.006 0-1.664 1.117-3.008 2.5-3.008 1.38 0 2.5 1.344 2.5 3.008z"
    />
    <Path fill="#FFF" d="M38.178 19.184c0 1.002-1 1.002-1 0s1-1.002 1 0z" />
    <Path
      fill="#F9C802"
      d="M2.251 41.6c-2.634 1.719 16.309 6.026 17.655-4.897 2.499-20.289-10.43.182-17.655 4.897z"
    />
    <Path
      fill="#F59E01"
      d="M13.003 43.511s.215-5.959 1.67-9.293c.639-1.463-4.772 5.531-4.555 9.658 0 0 1.39 0 2.885-.365z"
    />
    <Path
      fill="#F9C802"
      d="M61.749 41.6c2.634 1.719-16.309 6.026-17.655-4.897-2.499-20.289 10.43.182 17.655 4.897z"
    />
    <Path
      fill="#F59E01"
      d="M50.997 43.511s-.215-5.959-1.67-9.293c-.639-1.463 4.772 5.531 4.555 9.658 0 0-1.39 0-2.885-.365z"
    />
  </Svg>
);

export default Chick;
